@if (!profile.isProd) {
  <div class="env-ribbon" [attr.data-env]="profile.environment">
    {{ profile.environment }}
  </div>
}

@if (loading.isLoading()) {
  <div class="spinner-backdrop" aria-label="Loading" role="status">
    <div class="spinner-ring"></div>
  </div>
}

<main class="main">
  <div class="content">
    <app-rain-chart></app-rain-chart>
    <jhi-map></jhi-map>
    <app-waterbodies></app-waterbodies>
  </div>
</main>

<footer class="app-footer">
  @if (calendarDate()) {
    <span>System date: <strong>{{ calendarDate() | date:'MMM dd, yyyy hh:mm a' }}</strong></span>
  }
</footer>

